import { render, staticRenderFns } from "./CursosCapacitaciones.vue?vue&type=template&id=3227486b&scoped=true"
import script from "./CursosCapacitaciones.vue?vue&type=script&lang=js"
export * from "./CursosCapacitaciones.vue?vue&type=script&lang=js"
import style0 from "./CursosCapacitaciones.vue?vue&type=style&index=0&id=3227486b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3227486b",
  null
  
)

export default component.exports